var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.889 2.894v9.659c0 .354-.29.643-.645.644-1.5.003-4.011.316-5.744 2.129V5.218c0-.12.03-.233.089-.326 1.422-2.29 4.155-2.638 5.658-2.642h.001a.642.642 0 0 1 .64.644zM2.752 2.25h.001c1.503.004 4.236.352 5.659 2.642a.617.617 0 0 1 .088.326v10.108c-1.733-1.813-4.245-2.126-5.744-2.13a.646.646 0 0 1-.645-.643V2.894a.641.641 0 0 1 .641-.644zm14.604 2.227h-.467v8.076c0 .904-.737 1.641-1.643 1.644-1.271.003-3.368.251-4.853 1.657 2.568-.629 5.276-.22 6.819.131a.643.643 0 0 0 .788-.627V5.12a.645.645 0 0 0-.644-.644zm-16.245 0v8.076c0 .904.737 1.641 1.643 1.644 1.271.003 3.368.251 4.853 1.657-2.568-.63-5.276-.22-6.819.131A.643.643 0 0 1 0 15.358V5.12c0-.355.289-.644.644-.644h.467z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.82b10b4f4c8d4c1c638037e485d8d8fe.svg";
export { ForwardRef as ReactComponent };